import { MappedAEMProperties } from '../../../../types';
import LayoutContainer from '../../../common/Layout/Layout';
import styles from './Heading.module.scss';
import HeadingWithIcon, { HeadingWithIconProps } from '../../../common/HeadingWithIcon/HeadingWithIcon';

export type HeadingProps = {
  text: string;
} & MappedAEMProperties &
  HeadingWithIconProps;

const Heading = ({ text, ...rest }: HeadingProps) => {
  return (
    <LayoutContainer>
      <div className={styles.grid}>
        <HeadingWithIcon {...rest} classNames={{ container: styles.container }}>
          {text}
        </HeadingWithIcon>
      </div>
    </LayoutContainer>
  );
};

export default Heading;
